export default __webpack_public_path__ + "static/media/8.1a5ffe9c.svg";